<template>
	<label :class="['checkbox', className, { 'is-disabled': disabled }]">
		<input
			ref="inputEl"
			class="checkbox__input"
			type="checkbox"
			:checked="modelValue"
			:disabled="disabled"
			:aria-checked="indeterminate ? 'mixed' : modelValue ? 'true' : 'false'"
			@change="$emit('update:modelValue', $event.target.checked)"
		/>
		<div class="checkbox__checked">
			<svg
				width="12"
				height="9"
				viewBox="0 0 12 9"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.75 4.75L4.25 8.25L11.25 0.75"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</div>

		<div class="checkbox__text">
			<slot>{{ label }}</slot>
		</div>
	</label>
</template>

<script>
export default {
	name: 'BaseTermCheckbox',
	props: {
		modelValue: { type: Boolean, default: false },
		label: { type: String, default: '' },
		disabled: { type: Boolean, default: false },
		indeterminate: { type: Boolean, default: false },
		className: { type: String, default: '' },
	},
	emits: ['update:modelValue'],
	mounted() {
		if (this.indeterminate) this.$refs.inputEl.indeterminate = true;
	},
	watch: {
		indeterminate(v) {
			this.$refs.inputEl && (this.$refs.inputEl.indeterminate = v);
		},
	},
};
</script>

<style lang="scss" scoped>
.checkbox {
	cursor: pointer;
	display: flex;
	align-items: flex-start;
	gap: 10px;

	&.is-disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	&__input {
		display: none;
	}

	&__checked {
		margin-top: 2px;
		min-width: 20px;
		height: 20px;
		border: 1px solid var(--secondary-color);
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(196, 196, 196, 0.1);
		transition: all 0.3s ease;
		position: relative;

		svg {
			width: 12px;
			height: 9px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			transition: opacity 0.3s ease;
			opacity: 0;

			path {
				stroke: var(--primary-color);
			}
		}
	}

	&__input:checked + .checkbox__checked {
		background-color: var(--hint-color);
		border: 1px solid transparent;

		svg {
			opacity: 1;
		}
	}

	&__input:indeterminate + .checkbox__checked::after {
		content: '';
		width: 10px;
		height: 2px;
		border-radius: 2px;
		background: var(--primary-color);
	}

	&__text {
		text-align: left;
		font-size: 16px;
		font-family: var(--font-family-inter);
		font-weight: 400;
		line-height: 150%;
		:deep(a) {
			font-size: 16px;
			font-family: var(--font-family-inter);
			font-weight: 400;
			line-height: 150%;
			color: var(--hint-color);
			transition: border 0.3s ease;
			border-bottom: 1px solid transparent;
			@media (any-hover: hover) {
				&:hover {
					border-bottom: 1px solid var(--hint-color);
				}
			}
		}
	}
}
</style>
